import { createUseStyles } from 'react-jss';

export const useStyles = createUseStyles({
    mainContainer: ({ brandCode }) => ({
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'stretch',
        flexWrap: brandCode !== 'ctm' ? 'wrap' : 'nowrap',
        '@media (max-width: 768px)': {
            flexDirection: 'column'
        }
    }),
    buttonLink: () => ({
        width: '24%',
        marginRight: '0.5%',
        display: 'flex',
        '& a:nth-child(3n)': {
            marginRight: 0
        },
        '& > div': {
            display: 'flex',
            flex: 1
        },
        '@media (max-width: 768px)': {
            width: '100%'
        }
    })
});
